<template>
  <figure
    v-if="quoteText"
    class="ao__quote-block"
  >
    <DefaultIconsQuote class="ao__quote-block-icon" />
    <blockquote v-html="quoteText" />
    <figcaption v-if="quoteAuthor">{{ quoteAuthor }}</figcaption>
  </figure>
  <blockquote
    v-else-if="legacyQuoteText"
    class="ao__quote"
  >
    <DefaultIconsQuote />
    <p v-html="legacyQuoteText" />
  </blockquote>
</template>


<script setup lang="ts">
const {payload} = defineProps<{
  payload?: any
}>()

const quoteText = computed(() => {
  const content = payload?.content?.find((item: any) => item.type === 'quote_content')
  return content?.attributes?.text || content?.content?.[0]?.rendered || null
})

const quoteAuthor = computed(() => {
  const author = payload?.content?.find((item: any) => item.type === 'quote_author')
  return author?.attributes?.author || author?.content?.[0]?.rendered || null
})

// Legacy fallback for old format
const legacyQuoteText = computed(() => {
  const result = payload?.content?.find((item: any) => item.type === 'quote_author')
  return result?.contentHTML || null
})
</script>

<style lang="postcss" scoped>
</style>
